<template>
  <div class="card-body text-primary">
    <h4>
      Passwort ändern
    </h4>
    <form @submit.prevent="persistPassword()">
      <div class="form-group">
        <label for="currentPassword">Aktuelles Passwort</label>
        <input
          type="password"
          :class="{ 'is-invalid': errors.currentPassword }"
          class="form-control"
          id="currentPassword"
          placeholder="Passwort"
          autocomplete="current-password"
          name="settings.password"
          v-model="password.currentPassword"
        />
        <div
          v-if="errors.currentPassword"
          v-for="(error, key) in errors.currentPassword"
          :key="key"
          class="invalid-feedback"
        >
          {{ error }}
        </div>
      </div>
      <div class="form-group">
        <label for="newPassword">Neues Passwort</label>
        <input
          type="password"
          class="form-control"
          id="newPassword"
          placeholder="Passwort"
          autocomplete="new-password"
          name="settings.password"
          v-model="password.password"
        />
      </div>
      <div class="form-group">
        <label for="confirmNewPassword">Neues Passwort wiederholen</label>
        <input
          type="password"
          class="form-control"
          id="confirmNewPassword"
          placeholder="Passwort"
          autocomplete="new-password"
          name="settings.password"
          v-model="password.password_confirmation"
        />
      </div>
      <span v-if="errorMessage !== null" class="text-error">{{
        errorMessage
      }}</span>
      <div class="form-group">
        <button type="submit" class="btn btn-primary float-right">
          Passwort Speichern
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errors: {},
      errorMessage: null,
      password: {
        currentPassword: "",
        password: "",
        password_confirmation: ""
      }
    };
  },
  methods: {
    persistPassword() {
      this.errors = {};
      this.errorMessage = "";
      this.$http
        .patch(`/api/v1/user/${Laravel.user.id}`, { ...this.password })
        .then(() => {
          this.$notify({
            title: "Ihr Passwort wurde geändert",
            type: "success",
            group: "errors"
          });
        })
        .catch(error => {
          this.errors = error.response.data.errors;
          this.errorMessage = error.response.data.message;
        });
    }
  }
};
</script>
